import slugify from "slugify";
import _ from "lodash";
import { v4 } from "uuid";

var left = [
  "admiring",
  "adoring",
  "affectionate",
  "agitated",
  "amazing",
  "angry",
  "awesome",
  "blissful",
  "boring",
  "brave",
  "clever",
  "cocky",
  "compassionate",
  "competent",
  "condescending",
  "confident",
  "cranky",
  "dazzling",
  "determined",
  "distracted",
  "dreamy",
  "eager",
  "ecstatic",
  "elastic",
  "elated",
  "elegant",
  "eloquent",
  "epic",
  "fervent",
  "festive",
  "flamboyant",
  "focused",
  "friendly",
  "frosty",
  "gallant",
  "gifted",
  "goofy",
  "gracious",
  "happy",
  "hardcore",
  "heuristic",
  "hopeful",
  "hungry",
  "infallible",
  "inspiring",
  "jolly",
  "jovial",
  "keen",
  "kind",
  "laughing",
  "loving",
  "lucid",
  "mystifying",
  "modest",
  "musing",
  "naughty",
  "nervous",
  "nifty",
  "nostalgic",
  "objective",
  "optimistic",
  "peaceful",
  "pedantic",
  "pensive",
  "practical",
  "priceless",
  "quirky",
  "quizzical",
  "relaxed",
  "reverent",
  "romantic",
  "sad",
  "serene",
  "sharp",
  "silly",
  "sleepy",
  "stoic",
  "stupefied",
  "suspicious",
  "tender",
  "thirsty",
  "trusting",
  "unruffled",
  "upbeat",
  "vibrant",
  "vigilant",
  "vigorous",
  "wizardly",
  "wonderful",
  "xenodochial",
  "youthful",
  "zealous",
  "zen",
];

var right = [
  "albattani",
  "allen",
  "almeida",
  "agnesi",
  "archimedes",
  "ardinghelli",
  "aryabhata",
  "austin",
  "babbage",
  "banach",
  "bardeen",
  "bartik",
  "bassi",

  "beaver",

  "bell",

  "benz",

  "bhabha",

  "bhaskara",

  "blackwell",

  "bohr",

  "booth",

  "borg",

  "bose",

  "boyd",

  "brahmagupta",

  "brattain",

  "brown",

  "carson",

  "chandrasekhar",

  "shannon",

  "clarke",

  "colden",

  "cori",

  "cray",

  "curran",

  "curie",

  "darwin",

  "davinci",

  "dijkstra",

  "dubinsky",

  "easley",

  "edison",

  "einstein",

  "elion",

  "engelbart",

  "euclid",

  "euler",

  "fermat",

  "fermi",

  "feynman",

  "franklin",

  "galileo",

  "gates",

  "goldberg",

  "goldstine",

  "goldwasser",

  "golick",

  "goodall",

  "haibt",

  "hamilton",

  "hawking",

  "heisenberg",

  "hermann",

  "heyrovsky",

  "hodgkin",

  "hoover",

  "hopper",

  "hugle",

  "hypatia",

  "jackson",

  "jang",

  "jennings",

  "jepsen",

  "johnson",

  "joliot",

  "jones",

  "kalam",

  "kare",

  "keller",

  "kepler",

  "khorana",

  "kilby",

  "kirch",

  "knuth",

  "kowalevski",

  "lalande",

  "lamarr",

  "lamport",

  "leakey",

  "leavitt",

  "lewin",

  "lichterman",

  "liskov",

  "lovelace",

  "lumiere",

  "mahavira",

  "mayer",

  "mccarthy",

  "mcclintock",

  "mclean",

  "mcnulty",

  "meitner",

  "meninsky",

  "mestorf",

  "minsky",

  "mirzakhani",

  "morse",

  "murdock",

  "neumann",

  "newton",

  "nightingale",

  "nobel",

  "noether",

  "northcutt",

  "noyce",

  "panini",

  "pare",

  "pasteur",

  "payne",

  "perlman",

  "pike",

  "poincare",

  "poitras",

  "ptolemy",

  "raman",

  "ramanujan",

  "ride",

  "montalcini",

  "ritchie",

  "roentgen",

  "rosalind",

  "saha",

  "sammet",

  "shaw",

  "shirley",

  "shockley",

  "sinoussi",

  "snyder",

  "spence",

  "stallman",

  "stonebraker",

  "swanson",

  "swartz",

  "swirles",

  "tereshkova",

  "tesla",

  "thompson",

  "torvalds",

  "turing",

  "varahamihira",

  "visvesvaraya",

  "volhard",

  "villani",

  "wescoff",

  "wiles",

  "williams",

  "wilson",

  "wing",

  "wozniak",

  "wright",

  "yalow",
  "yonath",
];

export function makeid(length) {
  var result = "";
  var characters = "abcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

export function newRandomName() {
  return toTitleCase(
    `${left[Math.floor(Math.random() * left.length)]} ${
      right[Math.floor(Math.random() * right.length)]
    }`,
  );
}

export function generate_new_id(suffix = "") {
  return `${suffix ? suffix + "-" : ""}` + v4();
}

export function newRandomSlug(name) {
  if (name) {
    return `${slugify(name)}-${makeid(6)}`.toLowerCase();
  } else {
    return `${slugify(newRandomName())}-${makeid(6)}`.toLowerCase();
  }
}
